'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _navItem = require('./navItem');

var _navItem2 = _interopRequireDefault(_navItem);

var _navList = require('./navList');

var _navList2 = _interopRequireDefault(_navList);

var _reactI18next = require('react-i18next');

var _reactHtmlParser = require('react-html-parser');

var _reactHtmlParser2 = _interopRequireDefault(_reactHtmlParser);

var _reactFontawesome = require('react-fontawesome');

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function DesktopSecNav(props) {
    //No level 1 for phase 1
    var _useTranslation = (0, _reactI18next.useTranslation)('header'),
        t = _useTranslation.t;

    var _useState = (0, _react.useState)(),
        _useState2 = _slicedToArray(_useState, 2),
        mainDivHeight = _useState2[0],
        setMainDivHeight = _useState2[1];

    var _useState3 = (0, _react.useState)(""),
        _useState4 = _slicedToArray(_useState3, 2),
        solutionImage = _useState4[0],
        setSolutionImage = _useState4[1];

    var subNavLV2Info = (0, _lodash.isNumber)(props.subNavLV2Index) ? t("pages", { returnObjects: true })[props.subNavLV2Index].subNav : null;
    var subNavLV3Info = subNavLV2Info && props.subNavLV3Index != null ? subNavLV2Info.content[props.subNavLV3Index] : null;
    var showNavBar = !(0, _lodash.isEmpty)(subNavLV2Info) && (0, _lodash.get)(subNavLV2Info, "content") !== false;
    var showLGNav = false;
    var secNavRef = (0, _react.useRef)();

    !(0, _lodash.isEmpty)((0, _lodash.get)(subNavLV2Info, "content", [])) && (0, _lodash.get)(subNavLV2Info, "content", []).forEach(function (element) {
        if ((0, _lodash.isArray)(element.subNav.content)) {
            showLGNav = true;
        }
    });

    return showNavBar && _react2.default.createElement(
        'nav',
        {
            className: 'navbar \n                navbar-expand-sm \n                justify-content-between \n                align-items-center \n                navbar-sec \n                ' + (showNavBar ? 'd-sm-flex' : '') + '\n                ' + (!(0, _lodash.isEmpty)(props.subNavLV2Info) && 'active') + ' \n                ' + (props.darkMode ? 'dark-color' : '') + ' \n                \n                ' + ( /*!isEmpty(props.lv1Selection) &&*/showNavBar ? 'navbar-sec-full-height' : '') //navbar-sec
            ,

            onMouseLeave: function onMouseLeave() {
                props.setShowLV1(false);
                //reset lv1 selection
            }
        },
        showNavBar && (showLGNav ? _react2.default.createElement(
            'div',
            {
                className: 'navbar-sec-wrapper d-flex',
                ref: secNavRef,
                style: { marginLeft: (0, _lodash.isEmpty)(subNavLV3Info) ? props.marginLeft : "15%" }
            },
            _react2.default.createElement(BuildLV2Nav, {
                lv1Selection: props.lv1Selection,
                lv2Selection: props.lv2Selection,
                subNavLV3Index: props.subNavLV3Index,
                subNavLV2Info: subNavLV2Info,
                handleLV2MouseOver: props.handleLV2MouseOver,
                activeLV3: props.subNavLV3Index != null,
                onURLClick: props.onURLClick,
                setSubNavLV2Index: props.setSubNavLV2Index,
                returnSectionAndPath: props.returnSectionAndPath,
                setSolutionImage: setSolutionImage,
                returnFullURL: props.returnFullURL
            }),
            _react2.default.createElement(BuildLV3Nav, {
                subNavLV3Index: props.subNavLV3Index,
                lv2Selection: props.lv2Selection,
                subNavLV3Info: subNavLV3Info,
                onURLClick: props.onURLClick,
                setSubNavLV2Index: props.setSubNavLV2Index,
                returnSectionAndPath: props.returnSectionAndPath,
                setSolutionImage: setSolutionImage,
                solutionImage: solutionImage,
                returnFullURL: props.returnFullURL
            })
        ) : _react2.default.createElement(
            'div',
            { className: 'navbar-sec-wrapperSM col-auto d-flex', style: { marginLeft: props.marginLeft }, ref: secNavRef },
            _react2.default.createElement(BuildSmallNav, {
                subNavLV2Info: subNavLV2Info,
                onURLClick: props.onURLClick,
                setSubNavLV2Index: props.setSubNavLV2Index,
                returnSectionAndPath: props.returnSectionAndPath,
                returnFullURL: props.returnFullURL
            })
        ))
    );
}

var BuildLV1Nav = function BuildLV1Nav(props) {
    var _useTranslation2 = (0, _reactI18next.useTranslation)('header'),
        t = _useTranslation2.t;

    return _react2.default.createElement(
        'div',
        { className: 'sec-nav-list navbar-sec-lv1', style: { width: props.activeLV2 ? null : t("pages", { returnObjects: true })[1].subNav.cssDistance } },
        _react2.default.createElement(
            'h6',
            { className: 'sec-nav-title-business-type' },
            "Your business type:"
        ),
        _react2.default.createElement(
            'ul',
            { className: 'sce-nav-ul-list navbar-nav main-nav navbar-nav-sec sec-nav-ul', 'data-header': 'Your business type:' },
            !(0, _lodash.isEmpty)(t("businessType.businessTypes", { returnObjects: true })) && t("businessType.businessTypes", { returnObjects: true }).map(function (obj, key) {
                return _react2.default.createElement(_navItem2.default, {
                    key: key,
                    itemContent: obj,
                    handleMouseEnter: function handleMouseEnter(item) {
                        //console.log(item);
                        // props.returnSectionAndPath(item.url, 'subNav')
                    },
                    type: 'secNav',
                    isActive: obj.name == props.lv1Selection,
                    onURLClick: props.onURLClick,
                    returnSectionAndPath: props.returnSectionAndPath
                });
            })
        )
    );
};

var BuildLV2Nav = function BuildLV2Nav(props) {
    var subNavLV2Info = props.subNavLV2Info,
        lv1Selection = props.lv1Selection,
        activeLV3 = props.activeLV3,
        lv3Height = props.lv3Height,
        handleLV2MouseOver = props.handleLV2MouseOver,
        subNavLV3Index = props.subNavLV3Index,
        lv2Selection = props.lv2Selection,
        onURLClick = props.onURLClick,
        setSubNavLV2Index = props.setSubNavLV2Index,
        setSolutionImage = props.setSolutionImage;

    var isActive = !(0, _lodash.isEmpty)(subNavLV2Info); //!isEmpty(lv1Selection) && !isEmpty(subNavLV2Info);

    var _useTranslation3 = (0, _reactI18next.useTranslation)('header'),
        t = _useTranslation3.t;

    var _useState5 = (0, _react.useState)(false),
        _useState6 = _slicedToArray(_useState5, 2),
        mouseOverLevel3 = _useState6[0],
        setMouseoverLevel3 = _useState6[1];

    return _react2.default.createElement(
        'div',
        { className: 'navbar-sec-lv2 sec-nav-list ' + (isActive ? '' : 'no-width'),
            style: {
                width: activeLV3 || mouseOverLevel3 ? '42%' : '100%', //t("pages",{ returnObjects: true })[1].subNav.cssDistance,
                height: lv3Height > 0 ? lv3Height : null
            }
        },
        isActive && _react2.default.createElement(
            _react2.default.Fragment,
            null,
            _react2.default.createElement(
                'h6',
                { className: 'sec-nav-title-lv2' },
                (0, _reactHtmlParser2.default)(subNavLV2Info.title)
            ),
            _react2.default.createElement(
                'ul',
                { className: 'sce-nav-ul-list navbar-nav main-nav navbar-nav-sec sec-nav-ul' },
                !(0, _lodash.isEmpty)(subNavLV2Info.content) && subNavLV2Info.content.map(function (obj, key) {
                    if (!obj.MobileDisplayOnly) {
                        return _react2.default.createElement(
                            _react2.default.Fragment,
                            { key: key },
                            _react2.default.createElement(
                                _navItem2.default,
                                {
                                    key: key,
                                    itemContent: obj,
                                    handleMouseEnter: function handleMouseEnter(obj) {
                                        handleLV2MouseOver(obj, key);
                                        setMouseoverLevel3(true);
                                        setSolutionImage(obj.image);
                                    },
                                    handleItemClick: function handleItemClick(obj) {},
                                    type: 'secNav',
                                    isActive: obj.section == lv2Selection && subNavLV3Index == key,
                                    onURLClick: onURLClick,
                                    setSubNavLV2Index: setSubNavLV2Index,
                                    textColorClass: "hkbn-white",
                                    returnSectionAndPath: props.returnSectionAndPath
                                    // isDropdown={true}
                                    , fullURL: props.returnFullURL(obj.url)
                                },
                                (0, _lodash.get)(obj, "subNav.content.length", 0) > 0 && _react2.default.createElement(_reactFontawesome2.default, { name: 'caret-right' })
                            )
                        );
                    }
                })
            )
        )
    );
};

var BuildLV3Nav = function BuildLV3Nav(props) {
    var subNavLV3Info = props.subNavLV3Info,
        onURLClick = props.onURLClick,
        lv2Selection = props.lv2Selection,
        setSubNavLV2Index = props.setSubNavLV2Index,
        setSolutionImage = props.setSolutionImage,
        solutionImage = props.solutionImage,
        subNavLV3Index = props.subNavLV3Index;

    var isActive = !(0, _lodash.isEmpty)(subNavLV3Info);

    var _useTranslation4 = (0, _reactI18next.useTranslation)('header'),
        t = _useTranslation4.t;

    var pages = t("pages", { returnObjects: true });
    var suvNav = (0, _lodash.get)(pages, "[1].subNav", {});

    var _useState7 = (0, _react.useState)(null),
        _useState8 = _slicedToArray(_useState7, 2),
        lv3Selection = _useState8[0],
        setLv3Selection = _useState8[1];

    var _useState9 = (0, _react.useState)(null),
        _useState10 = _slicedToArray(_useState9, 2),
        expandedList = _useState10[0],
        setExpandedList = _useState10[1];
    // console.log("solutionImage",solutionImage)


    (0, _react.useEffect)(function () {
        setExpandedList(null);
    }, [lv2Selection]);

    return _react2.default.createElement(
        'div',
        { className: (isActive ? "" : "no-width") + ' navbar-sec-lv3 sec-nav-list', style: { width: '58%' } },
        isActive && _react2.default.createElement(
            _react2.default.Fragment,
            null,
            _react2.default.createElement(
                'h6',
                { className: 'sec-nav-title-lv3' },
                (0, _reactHtmlParser2.default)(subNavLV3Info.title)
            ),
            _react2.default.createElement(
                'div',
                { className: 'row sce-nav-ul-row' },
                _react2.default.createElement(
                    'ul',
                    { className: 'sce-nav-ul-list navbar-nav main-nav navbar-nav-sec sec-nav-ul-lv3 col-6' },
                    !(0, _lodash.isEmpty)((0, _lodash.get)(props, "subNavLV3Info.subNav.content", [])) && (0, _lodash.get)(props, "subNavLV3Info.subNav.content", []).map(function (obj, key) {
                        var isLV3Active = lv3Selection == key;
                        return _react2.default.createElement(
                            _navList2.default,
                            {
                                key: key,
                                itemContent: obj,
                                type: 'thirdNav',
                                isActiveLv3: (0, _lodash.isArray)(obj.subNav.content) && !(0, _lodash.isEmpty)(obj.subNav.content),
                                isSelected: isLV3Active,
                                handleItemClick: function handleItemClick() {
                                    if (!(0, _lodash.isArray)(obj.subNav.content) && !(0, _lodash.isEmpty)(obj.subNav.content)) {
                                        setExpandedList(key);
                                    }
                                    setLv3Selection(isLV3Active ? null : key);
                                },
                                handleMouseEnter: function handleMouseEnter(item) {
                                    if (!(0, _lodash.isArray)(obj.subNav.content) && !(0, _lodash.isEmpty)(obj.subNav.content)) {
                                        setExpandedList(key);
                                    }
                                    setSolutionImage(obj.image);
                                },
                                onURLClick: onURLClick,
                                isExpand: expandedList == key,
                                textColorClass: 'hkbn-blue',
                                returnSectionAndPath: props.returnSectionAndPath,
                                fullURL: props.returnFullURL(obj.url)
                            },
                            (isLV3Active || expandedList == key) && _react2.default.createElement(
                                'ul',
                                { className: 'sce-nav-ul-list' },
                                !(0, _lodash.isEmpty)((0, _lodash.get)(obj, "subNav.content", [])) && (0, _lodash.get)(obj, "subNav.content", []).map(function (e, i) {
                                    return _react2.default.createElement(_navItem2.default, {
                                        key: i,
                                        itemContent: e,
                                        handleMouseEnter: function handleMouseEnter(item) {
                                            setSolutionImage(e.image);
                                        },
                                        type: 'subNav3',
                                        onURLClick: onURLClick,
                                        setSubNavLV2Index: setSubNavLV2Index,
                                        textColorClass: 'hkbn-blue',
                                        returnSectionAndPath: props.returnSectionAndPath
                                        // isDropdown={true}
                                        , fullURL: props.returnFullURL(e.url)
                                    });
                                })
                            )
                        );
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'navbar-sec-lv3-img col-6', style: { height: "100%" } },
                    _react2.default.createElement('img', {
                        src: solutionImage,
                        alt: (0, _lodash.get)(suvNav, 'content[' + subNavLV3Index + '].alt', ""),
                        className: 'navbar-nav-sec-img'
                    }),
                    _react2.default.createElement(
                        'span',
                        null,
                        (0, _lodash.get)(suvNav, 'content[' + subNavLV3Index + '].desc', "")
                    )
                )
            )
        )
    );
};

var BuildSmallNav = function BuildSmallNav(props) {
    // console.log(props.subNavLV2Info)
    return _react2.default.createElement(
        'div',
        { className: 'navbar-sec-small sec-nav-list' },
        _react2.default.createElement(
            'ul',
            { className: 'sce-nav-ul-list navbar-nav main-nav navbar-nav-sec sec-nav-ul', 'data-header': 'Your business type:' },
            !(0, _lodash.isEmpty)(props.subNavLV2Info.content) && props.subNavLV2Info.content.map(function (obj, key) {
                return _react2.default.createElement(_navItem2.default, {
                    key: key,
                    itemContent: obj,
                    handleMouseEnter: function handleMouseEnter(item) {},
                    type: 'secNav',
                    onURLClick: props.onURLClick,
                    setSubNavLV2Index: props.setSubNavLV2Index,
                    returnSectionAndPath: props.returnSectionAndPath,
                    fullURL: props.returnFullURL(obj.url)
                });
            })
        )
    );
};

exports.default = DesktopSecNav;